// Mafia API client — all calls go through REACT_APP_BACKEND_URL with /api prefix
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const BASE = `${BACKEND}/api/mafia`;

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}

// ---------- Roles ----------
export const listRoles = () => request('/roles');
export const createRole = (data) =>
  request('/roles', { method: 'POST', body: JSON.stringify(data) });
export const updateRole = (id, data) =>
  request(`/roles/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteRole = (id) =>
  request(`/roles/${id}`, { method: 'DELETE' });
export const resetDefaultRoles = () =>
  request('/roles/reset-defaults', { method: 'POST' });

// ---------- Games ----------
export const listGames = () => request('/games');
export const createGame = (data) =>
  request('/games', { method: 'POST', body: JSON.stringify(data) });
export const getGame = (id) => request(`/games/${id}`);
export const updateGame = (id, data) =>
  request(`/games/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteGame = (id) =>
  request(`/games/${id}`, { method: 'DELETE' });
export const assignRoles = (id, data) =>
  request(`/games/${id}/assign`, { method: 'POST', body: JSON.stringify(data) });
export const startGame = (id) =>
  request(`/games/${id}/start`, { method: 'POST' });
export const nextStep = (id) =>
  request(`/games/${id}/next`, { method: 'POST' });
export const nextRole = (id) =>
  request(`/games/${id}/next-role`, { method: 'POST' });
export const switchPhase = (id) =>
  request(`/games/${id}/switch-phase`, { method: 'POST' });
export const previousStep = (id) =>
  request(`/games/${id}/back`, { method: 'POST' });
export const eliminatePlayer = (id, data) =>
  request(`/games/${id}/eliminate`, { method: 'POST', body: JSON.stringify(data) });
export const revivePlayer = (id, data) =>
  request(`/games/${id}/revive`, { method: 'POST', body: JSON.stringify(data) });
export const addEvent = (id, data) =>
  request(`/games/${id}/event`, { method: 'POST', body: JSON.stringify(data) });
export const patchEvent = (id, eventId, data) =>
  request(`/games/${id}/event/${eventId}`, { method: 'PATCH', body: JSON.stringify(data) });
export const upsertRoundComment = (id, data) =>
  request(`/games/${id}/round-comment`, { method: 'PUT', body: JSON.stringify(data) });
export const endGame = (id, data) =>
  request(`/games/${id}/end`, { method: 'POST', body: JSON.stringify(data) });
